
import axios from 'axios'

const USER_URL = '/me/'

export default {
  async getUserInfo () {
    return (await axios.get(USER_URL)).data
  }
}
